import { Stack } from '@mui/material';
import { APP_IMG } from 'assets';
import { Fragment } from 'react';
import { TermContentText } from '../../TermsModal/styles';

export const FullPackageTerm = () => {
  return (
    <Fragment>
      <TermContentText>
        1. For the Term of the Agreement, the hourly fees payable by the Client
        is:
        <Stack spacing={1}>
          <img
            src={APP_IMG.termsPlans}
            alt="APP_IMG.termsPlans"
            style={{ width: '100%', maxWidth: 328 }}
          />
          <img
            src={APP_IMG.termsSurcharges}
            alt="APP_IMG.termsSurcharges"
            style={{ width: '100%', maxWidth: 328 }}
          />
        </Stack>
      </TermContentText>
      <TermContentText>
        2. For sits starting or ending after 11PM or before 7AM, commuting
        expenses will be incurred as necessary. The Client will be billed for
        these commuting expenses at the end of each month.
      </TermContentText>
      <TermContentText>
        3. The Company shall, before either of the following events:
        <Stack mt={1} ml={2} spacing={1}>
          <TermContentText>
            a. the Trial or the 2nd Trial, as the case may be (“First Payment”);
            and
          </TermContentText>
          <TermContentText>
            b. the end of each subsequent calendar month for which the Sitter
            rendered the Service (“Subsequent Payment”); provide the Client with
            a digital invoice for payment of the Service Fee to be made in
            accordance with paragraph 2 of this Schedule.
          </TermContentText>
          <TermContentText>
            c. During the Trial, the hourly rate will be set at $35. An
            additional surcharge of $5 per hour will be applied if the trial
            request is made within 48 hours. A surcharge of $5 per hour will
            also be applied per additional kid. Subsequent payments will be
            calculated by deducting from the agreed-upon package.
          </TermContentText>
        </Stack>
      </TermContentText>
      <TermContentText>
        4. In the event that the job is cancelled with less than 24 hours’
        notice before the scheduled start time of the trial, a penalty of 1 hour
        of the hourly rate will be applied. This penalty is intended to
        compensate the sitter for their commitment and potential lost
        opportunities.
      </TermContentText>
      <TermContentText>
        5. The Sitter's responsibility extends to all assigned children
        throughout the session, regardless of whether a child is actively
        requiring care at any given time (e.g., during naps or independent
        play). As such, the total hourly rate remains fixed across each sit and
        cannot be split or prorated based on individual child activity.
      </TermContentText>
      <TermContentText>
        6. In the event this Agreement is terminated under Clause 5, the Client
        will not be entitled to any refunds of the Service Fee already paid.{' '}
      </TermContentText>
      <TermContentText>
        7. The validity period for all purchased packages is six months from the
        date of purchase. It is the Client's responsibility to use the services
        within this timeframe.
      </TermContentText>
    </Fragment>
  );
};

export default FullPackageTerm;
